import axios from 'axios';
import { authService } from './AuthService';
import { disconnectWebSocket } from '../config/WebsocketService';
import { isAuthError, isPublicApiRequest } from '../utils/authUtils';

let isRedirectingToLogin = false;

function redirectToLogin(message) {
  if (isRedirectingToLogin || window.location.pathname === '/') {
    return;
  }

  isRedirectingToLogin = true;
  disconnectWebSocket({ allowReconnect: false });
  authService.clearAuthData();
  sessionStorage.setItem('sessionExpiredMessage', message);
  window.location.replace('/');
}

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const requestUrl = error.config?.url || '';

      if (!isPublicApiRequest(requestUrl) && isAuthError(error)) {
        redirectToLogin('Tu sesión expiró. Por favor, iniciá sesión nuevamente.');
      }

      return Promise.reject(error);
    }
  );
}
